'use strict';

var request = require('./blueAgent');
var assign = require('object-assign');
var ServiceClientBase = require('./serviceClientBase');

module.exports = assign({}, ServiceClientBase.prototype, {
    /**
     *
     * @param params
     * @param {String} params.token
     * @param {String} params.deviceId
     * @returns {Bluebird Promise}
     */
    get: function get(params) {
        var qs = this.pullQueryStringParams(params);
        var data = {
            token: params.token,
            deviceId: params.deviceId
        };
        var favoriteData = JSON.stringify(data);
        return this.postApiRequest(this.getUrl().favoriteItemsGet, qs, favoriteData);
    },

    /**
     *
     * @param params
     * @param {String} params.token
     * @param {String} params.deviceId
     * @param {Array} params.items
     * @param {Object} params.items.item
     * @param {String} params.items.item.favoriteName
     * @param {Object} params.items.item.product
     * @param {String} params.items.item.product.id the productId
     * @returns {Bluebird Promise}
     */
    save: function save(params) {
        var qs = this.pullQueryStringParams(params);
        var data = {
            token: params.token,
            deviceId: params.deviceId,
            items: params.items
        };
        var favoriteData = JSON.stringify(data);
        return this.postApiRequest(this.getUrl().favoriteItemsSave, qs, favoriteData);
    },

    /**
     *
     * @param params
     * @param {String} params.token
     * @param {String} params.deviceId
     * @param {String} params.favoriteName
     * @returns {Bluebird Promise}
     */
    delete: function _delete(params) {
        var qs = this.pullQueryStringParams(params);
        var data = {
            token: params.token,
            deviceId: params.deviceId,
            favoriteName: params.favoriteName
        };
        var favoriteData = JSON.stringify(data);
        return this.postApiRequest(this.getUrl().favoriteItemsDelete, qs, favoriteData);
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/service_clients/favoriteItemsServiceClient.js
// module id = 840
// module chunks = 0